var visibleClassName = 'react-navigation_navbar-hideOnScrollDown-visible';
var hiddenClassName = 'react-navigation_navbar-hideOnScrollDown-hidden';

var hideOnScrollDown = function hideOnScrollDown(_ref) {
  var navbarRef = _ref.navbarRef,
      scroll = _ref.scroll;

  var _ref2 = navbarRef.current || {},
      clientHeight = _ref2.clientHeight;

  var current = scroll.current,
      previous = scroll.previous;
  var isVisible = previous.y >= current.y || current.y <= clientHeight;
  return {
    className: isVisible ? visibleClassName : hiddenClassName
  };
};

export default hideOnScrollDown;